import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "@ui/Card";
import { Separator } from "@ui/Separator";
import type { Price } from "@/types/Price";
import { cn } from "@/utils/tailwind";

interface PriceCardProps {
  price: Price;
  dataTest?: string;
}

export const PriceCard: FC<PriceCardProps> = ({ price, dataTest }) => {
  const { t } = useTranslation();
  const currency = t("zl");

  const Row = (id: string, label: string, value: number | string, bold = false) => (
    <div
      className={cn("grid grid-cols-2 items-center", bold && "font-bold")}
      data-test={dataTest ? `${dataTest}-${id}-row` : undefined}
    >
      <span data-test={dataTest ? `${dataTest}-${id}-label` : undefined}>{label}</span>
      <span className="text-right" data-test={dataTest ? `${dataTest}-${id}-value` : undefined}>
        {value} {currency}
      </span>
    </div>
  );

  return (
    <Card className="flex w-full flex-col gap-4! border px-8! py-6! text-base font-medium">
      {Row("price", t("price"), price.price)}
      {Row("vat", t("vat"), price.tax)}
      <Separator />
      {Row("total", t("totalPrice"), price.total, true)}
    </Card>
  );
};

export default PriceCard;
